import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  orderBy,
  limit,
  getDocs,
  getCountFromServer,
} from 'firebase/firestore';
import type { PurchaseEvent, PurchaseItem } from '../types';
import { getDb } from './firebase';

const PURCHASES_COLLECTION = 'purchases';
const RECENT_ITEMS_COLLECTION = 'recent_sold_items';

/** Registra una compra en Firestore y actualiza productos recién vendidos */
export async function recordPurchase(siteId: string, event: PurchaseEvent): Promise<void> {
  const db = getDb();
  if (!db) return;

  try {
    await addDoc(collection(db, 'sites', siteId, PURCHASES_COLLECTION), {
      ...event,
      siteId,
      recordedAt: serverTimestamp(),
      platform: event.platform || 'unknown',
    });

    for (const item of event.items) {
      await addDoc(collection(db, 'sites', siteId, RECENT_ITEMS_COLLECTION), {
        ...item,
        siteId,
        transactionId: event.transaction_id,
        value: event.value,
        currency: event.currency,
        recordedAt: serverTimestamp(),
      });
    }
  } catch (e) {
    console.warn('[Kenbun] Error recording purchase:', e);
  }
}

/** Obtiene los últimos N productos vendidos para el popup */
export async function getRecentlySold(siteId: string, maxItems: number = 5): Promise<PurchaseItem[]> {
  const db = getDb();
  if (!db) return [];

  try {
    const q = query(
      collection(db, 'sites', siteId, RECENT_ITEMS_COLLECTION),
      orderBy('recordedAt', 'desc'),
      limit(maxItems)
    );
    const snap = await getDocs(q);
    const items: PurchaseItem[] = [];
    const seen = new Set<string>();
    for (const d of snap.docs) {
      const data = d.data();
      if (seen.has(data.item_id)) continue;
      seen.add(data.item_id);
      items.push({
        item_id: data.item_id,
        item_name: data.item_name,
        price: data.price,
        quantity: data.quantity,
        image_url: data.image_url,
        product_url: data.product_url,
      });
    }
    return items;
  } catch (e) {
    console.warn('[Kenbun] Error fetching recently sold:', e);
    return [];
  }
}

/** Cuenta de compras (para estadísticas) */
export async function getPurchaseCount(siteId: string): Promise<number> {
  const db = getDb();
  if (!db) return 0;
  try {
    const q = query(
      collection(db, 'sites', siteId, PURCHASES_COLLECTION)
    );
    const snap = await getCountFromServer(q);
    return snap.data().count;
  } catch {
    return 0;
  }
}
